import React from 'react';

interface IAffiliatesPending {
  affiliate: any;
  handleInvite: any;
}

const AffiliatesPending: React.FC<IAffiliatesPending> = ({ affiliate, handleInvite }) => {
  return (
    <div className='affiliates-pending-container'>
      <div className='affiliates-pending-table'>
        <div className='affiliates-pending-header'>
          <div className='affiliates-pending-header-group'>
            <div className='affiliates-pending-header-group-text'>
              <div className='affiliates-pending-header-group-frame'>
                <div className='affiliates-pending-header-group-inner'>
                  <div className='affiliates-pending-header-group-primary'>
                    Pending invites
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='affiliates-pending-column'>
          <div className='affiliates-pending-column-frame'>
            <div className='affiliates-pending-column-group'>
              <div className='affiliates-pending-column-text'>
                Affiliate Name
              </div>
            </div>
          </div>
        </div>
        {!affiliate.isLoading && affiliate?.data?.pending?.length === 0 && (
          <div className='affiliates-pending-team-row'></div>
        )}
        {!affiliate.isLoading && affiliate?.data?.pending?.map((invite: any, index: number) => (
          <div key={index} className='affiliates-pending-team-row'>
            <div className='affiliates-pending-team-frame'>
              <div className='affiliates-pending-team-inner'>
                <div className='affiliates-pending-team-title'>
                  <div className='affiliates-pending-team-title-group'>
                    <div className='affiliates-pending-team-title-text'>
                      {invite.name}
                    </div>
                  </div>
                </div>
                <div className='affiliates-pending-team-actions'>
                  <div
                    className='affiliates-pending-team-btn'
                    onClick={() => handleInvite('approve', index, invite)}
                  >
                    <div className='affiliates-pending-team-btn-text'>
                      {invite.type === 'incoming' ? 'Approve' : 'Join'}
                    </div>
                  </div>
                  <div
                    className='affiliates-pending-team-btn'
                    onClick={() => handleInvite('deny', index, invite)}
                  >
                    <div className='affiliates-pending-team-btn-text'>
                      Deny
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AffiliatesPending;
